<template>
	<el-container class="setting-page">
		<el-main>
			<div class="setting-container">
				<div class="setting-aside">
					<div class="setting-title">系统设置</div>
					<div class="setting-menu">
						<div class="menu-item" :class="{ active: activeTab === 'info' }" @click="activeTab = 'info'">
							<i class="el-icon-user"></i>
							<span>个人信息</span>
						</div>
						<div class="menu-item" :class="{ active: activeTab === 'password' }" @click="activeTab = 'password'">
							<i class="el-icon-lock"></i>
							<span>修改密码</span>
						</div>
						<div class="menu-item" :class="{ active: activeTab === 'channel' }" @click="activeTab = 'channel'">
							<i class="el-icon-link"></i>
							<span>接入链接</span>
						</div>
						<div class="menu-item" :class="{ active: activeTab === 'quick' }" @click="activeTab = 'quick'">
							<i class="el-icon-chat-dot-round"></i>
							<span>快捷设置</span>
						</div>
						<div class="menu-item" :class="{ active: activeTab === 'phrase' }" @click="activeTab = 'phrase'">
							<i class="el-icon-collection"></i>
							<span>常用词管理</span>
						</div>
					</div>
				</div>
				<div class="setting-content">
					<div v-if="activeTab === 'info'" class="content-pane fade-in">
						<div class="pane-header">个人信息</div>
						<div class="info-form-wrap">
							<el-form :model="userInfo" label-width="100px" :rules="rules" ref="settingForm" size="medium">
								<el-form-item label="用户头像">
									<file-upload class="avatar-uploader" :action="imageAction" :showLoading="true" :maxSize="maxSize"
										:isPermanent="true" @success="onUploadSuccess"
										:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
										<div class="avatar-wrap">
											<img v-if="userInfo.headImage" :src="userInfo.headImage" class="avatar">
											<div v-else class="avatar-placeholder">
												<i class="el-icon-plus"></i>
											</div>
											<div class="avatar-mask">
												<i class="el-icon-camera"></i>
												<span>更换头像</span>
											</div>
										</div>
									</file-upload>
								</el-form-item>
								<el-form-item label="登录账号">
									<el-input disabled v-model="userInfo.userName" class="custom-input"></el-input>
								</el-form-item>
								<el-form-item prop="nickName" label="用户昵称">
									<el-input v-model="userInfo.nickName" maxlength="20" placeholder="设置一个亲切的昵称" class="custom-input"></el-input>
								</el-form-item>
								<el-form-item label="用户性别">
									<el-radio-group v-model="userInfo.sex">
										<el-radio :label="0">男生</el-radio>
										<el-radio :label="1">女生</el-radio>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="个性签名">
									<el-input type="textarea" v-model="userInfo.signature" :rows="4" maxlength="64" placeholder="向大家介绍一下自己吧" class="custom-input"></el-input>
								</el-form-item>
								<el-form-item label="离线自动回复">
									<div class="offline-reply-card">
										<el-switch
											v-model="agentSetting.offlineReplyEnabled"
											active-text="开启"
											inactive-text="关闭">
										</el-switch>
										<el-input
											type="textarea"
											v-model="agentSetting.offlineReply"
											:rows="4"
											maxlength="1024"
											show-word-limit
											placeholder="例如：您好，当前客服暂时不在线，您可以先留言，我上线后会第一时间回复您。"
											class="custom-input offline-reply-input">
										</el-input>
										<div class="offline-reply-tip">访客首次进入且当前客服不在线时，将自动发送这段回复语。</div>
									</div>
								</el-form-item>
								<el-form-item class="form-actions">
									<el-button type="primary" @click="onSubmit()" class="gradient-btn">保存修改</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>

					<div v-else-if="activeTab === 'password'" class="content-pane fade-in">
						<div class="pane-header">修改密码</div>
						<div class="info-form-wrap">
							<el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px" size="medium">
								<el-form-item label="旧密码" prop="oldPassword">
									<el-input v-model="passwordForm.oldPassword" type="password" show-password maxlength="64" placeholder="请输入当前密码" class="custom-input"></el-input>
								</el-form-item>
								<el-form-item label="新密码" prop="newPassword">
									<el-input v-model="passwordForm.newPassword" type="password" show-password maxlength="64" placeholder="请输入新密码" class="custom-input"></el-input>
								</el-form-item>
								<el-form-item label="确认密码" prop="confirmPassword">
									<el-input v-model="passwordForm.confirmPassword" type="password" show-password maxlength="64" placeholder="请再次输入新密码" class="custom-input"></el-input>
								</el-form-item>
								<el-form-item class="form-actions">
									<el-button type="primary" :loading="passwordSubmitting" @click="submitPassword" class="gradient-btn">确认修改</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>

					<div v-else-if="activeTab === 'channel'" class="content-pane fade-in">
						<div class="pane-header">
							<span>接入链接</span>
							<el-button type="primary" size="small" icon="el-icon-plus" @click="openChannelDialog()" class="gradient-btn-small">新建链接</el-button>
						</div>
						<div class="channel-list-wrap" v-loading="channelLoading">
							<el-table :data="channels" size="medium" stripe class="custom-table">
								<el-table-column prop="channelName" label="渠道名称" min-width="120"></el-table-column>
								<el-table-column prop="domainName" label="前端域名" min-width="180" show-overflow-tooltip></el-table-column>
								<el-table-column label="状态" width="100" align="center">
									<template slot-scope="{ row }">
										<div class="status-dot" :class="row.status === 1 ? 'online' : 'offline'">
											<span>{{ row.status === 1 ? '已启用' : '已停用' }}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="接入链接" min-width="250">
									<template slot-scope="{ row }">
										<div class="link-box">
											<span class="link-url">{{ row.accessLink }}</span>
											<el-button type="text" size="small" @click="copyLink(row.accessLink)" icon="el-icon-document-copy">复制</el-button>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="160" align="right">
									<template slot-scope="{ row }">
										<el-button type="text" size="small" @click="openChannelDialog(row)" class="action-btn edit">编辑</el-button>
										<el-button type="text" size="small" @click="toggleChannelStatus(row)" 
											:class="['action-btn', row.status === 1 ? 'disable' : 'enable']">
											{{ row.status === 1 ? '停用' : '启用' }}
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div v-if="!channels.length" class="empty-holder">
								<i class="el-icon-link"></i>
								<p>暂无接入链接，点击上方按钮创建</p>
							</div>
						</div>
					</div>

					<div v-else-if="activeTab === 'quick'" class="content-pane fade-in">
						<div class="pane-header">
							<span>快捷设置</span>
							<el-button type="primary" size="small" icon="el-icon-plus" @click="openQuickDialog()" class="gradient-btn-small">新建快捷词</el-button>
						</div>
						<div class="quick-setting-tip">
							快捷词供访客端展示按钮，访客点击后系统自动回复对应的快捷语。
						</div>
						<div class="channel-list-wrap" v-loading="quickReplyLoading">
							<el-table :data="quickReplies" size="medium" stripe class="custom-table">
								<el-table-column prop="keyword" label="快捷词" min-width="140"></el-table-column>
								<el-table-column prop="content" label="快捷语" min-width="280" show-overflow-tooltip></el-table-column>
								<el-table-column label="状态" width="100" align="center">
									<template slot-scope="{ row }">
										<div class="status-dot" :class="row.status === 1 ? 'online' : 'offline'">
											<span>{{ row.status === 1 ? '已启用' : '已停用' }}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="220" align="right">
									<template slot-scope="{ row }">
										<el-button type="text" size="small" @click="openQuickDialog(row)" class="action-btn edit">编辑</el-button>
										<el-button type="text" size="small" @click="toggleQuickReplyStatus(row)"
											:class="['action-btn', row.status === 1 ? 'disable' : 'enable']">
											{{ row.status === 1 ? '停用' : '启用' }}
										</el-button>
										<el-button type="text" size="small" @click="deleteQuickReply(row)" class="action-btn disable">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div v-if="!quickReplies.length" class="empty-holder">
								<i class="el-icon-chat-dot-round"></i>
								<p>暂无快捷词，点击上方按钮创建</p>
							</div>
						</div>
					</div>

					<div v-else-if="activeTab === 'phrase'" class="content-pane fade-in">
						<div class="pane-header">
							<span>常用词管理</span>
							<div class="pane-header-actions">
								<el-button size="small" icon="el-icon-folder-add" @click="openPhraseCategoryDialog()">新建分类</el-button>
								<el-button type="primary" size="small" icon="el-icon-plus" @click="openPhraseDialog()" class="gradient-btn-small">新建常用词</el-button>
							</div>
						</div>
						<div class="quick-setting-tip">
							常用词仅供代理在聊天窗口右侧快捷发送，不会展示给访客。
						</div>
						<div class="quick-manage-wrap" v-loading="phraseLoading">
							<div class="quick-category-panel">
								<div class="panel-title">分类列表</div>
								<div
									v-for="category in phraseCategories"
									:key="category.id"
									class="category-item"
									:class="{ active: selectedPhraseCategoryId === category.id }"
									@click="selectPhraseCategory(category)">
									<div class="category-item-main">
										<span class="category-item-name">{{ category.name }}</span>
										<span class="category-item-count">{{ (category.phrases || []).length }}</span>
									</div>
									<div class="category-item-actions" @click.stop>
										<el-button type="text" size="mini" @click="openPhraseCategoryDialog(category)">编辑</el-button>
										<el-button type="text" size="mini" class="danger-text" @click="deletePhraseCategory(category)">删除</el-button>
									</div>
								</div>
								<div v-if="!phraseCategories.length" class="empty-holder small">
									<p>暂无分类，请先创建</p>
								</div>
							</div>
							<div class="quick-reply-panel">
								<div class="panel-title">
									<span>{{ selectedPhraseCategoryName }}</span>
									<span class="panel-sub">点击上方按钮可新建常用词</span>
								</div>
								<el-table :data="currentPhrases" size="medium" stripe class="custom-table">
									<el-table-column prop="content" label="常用词" min-width="320" show-overflow-tooltip></el-table-column>
									<el-table-column label="状态" width="100" align="center">
										<template slot-scope="{ row }">
											<div class="status-dot" :class="row.status === 1 ? 'online' : 'offline'">
												<span>{{ row.status === 1 ? '已启用' : '已停用' }}</span>
											</div>
										</template>
									</el-table-column>
									<el-table-column label="操作" width="220" align="right">
										<template slot-scope="{ row }">
											<el-button type="text" size="small" @click="openPhraseDialog(row)" class="action-btn edit">编辑</el-button>
											<el-button type="text" size="small" @click="togglePhraseStatus(row)"
												:class="['action-btn', row.status === 1 ? 'disable' : 'enable']">
												{{ row.status === 1 ? '停用' : '启用' }}
											</el-button>
											<el-button type="text" size="small" @click="deletePhrase(row)" class="action-btn disable">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
								<div v-if="!currentPhrases.length" class="empty-holder">
									<i class="el-icon-collection"></i>
									<p>当前分类暂无常用词</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-main>

		<el-dialog :title="editingChannelId ? '编辑接入链接' : '新建接入链接'" :visible.sync="showChannelDialog" width="500px" append-to-body class="custom-dialog">
			<el-form ref="channelForm" :model="channelForm" :rules="channelRules" label-width="100px" size="medium">
				<el-form-item label="前端域名" prop="domainId">
					<el-select v-model="channelForm.domainId" placeholder="请选择访客前端域名" class="custom-input">
						<el-option
							v-for="domain in channelDomains"
							:key="domain.id"
							:label="formatDomainLabel(domain)"
							:value="domain.id"
							:disabled="isDomainOptionDisabled(domain)">
						</el-option>
					</el-select>
					<div class="channel-domain-tip">由总后台统一维护访客入口域名，停用域名不会影响历史链接。</div>
				</el-form-item>
				<el-form-item label="渠道名称" prop="channelName">
					<el-input v-model="channelForm.channelName" maxlength="64" placeholder="例如：官网客服、APP入口" class="custom-input"></el-input>
				</el-form-item>
				<el-form-item label="页面标题">
					<el-input v-model="channelForm.landingTitle" maxlength="64" placeholder="访客看到的浏览器标题" class="custom-input"></el-input>
				</el-form-item>
				<el-form-item label="头像链接">
					<el-input v-model="channelForm.landingAvatar" maxlength="255" placeholder="访客看到的客服头像URL" class="custom-input"></el-input>
				</el-form-item>
				<el-form-item label="欢迎语">
					<el-input v-model="channelForm.welcomeMessage" type="textarea" :rows="4" maxlength="1024" placeholder="访客进入后自动发送的第一条消息" class="custom-input"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="showChannelDialog = false" round>取 消</el-button>
				<el-button size="medium" type="primary" :loading="channelSubmitting" @click="submitChannel" class="gradient-btn" round>保 存</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="editingPhraseCategoryId ? '编辑分类' : '新建分类'" :visible.sync="showPhraseCategoryDialog" width="460px" append-to-body class="custom-dialog">
			<el-form ref="phraseCategoryFormRef" :model="phraseCategoryForm" :rules="phraseCategoryRules" label-width="100px" size="medium">
				<el-form-item label="分类名称" prop="name">
					<el-input v-model="phraseCategoryForm.name" maxlength="64" placeholder="例如：充值、常见问题" class="custom-input"></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input-number v-model="phraseCategoryForm.sortOrder" :min="0" :max="9999"></el-input-number>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="showPhraseCategoryDialog = false" round>取 消</el-button>
				<el-button size="medium" type="primary" :loading="phraseCategorySubmitting" @click="submitPhraseCategory" class="gradient-btn" round>保 存</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="editingPhraseId ? '编辑常用词' : '新建常用词'" :visible.sync="showPhraseDialog" width="520px" append-to-body class="custom-dialog">
			<el-form ref="phraseFormRef" :model="phraseForm" :rules="phraseRules" label-width="100px" size="medium">
				<el-form-item label="所属分类" prop="categoryId">
					<el-select v-model="phraseForm.categoryId" placeholder="请选择分类" class="custom-input">
						<el-option
							v-for="category in phraseCategories"
							:key="category.id"
							:label="category.name"
							:value="category.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="常用词" prop="content">
					<el-input v-model="phraseForm.content" type="textarea" :rows="4" maxlength="500" placeholder="例如：您好，请问有什么可以帮到您？" class="custom-input"></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input-number v-model="phraseForm.sortOrder" :min="0" :max="9999"></el-input-number>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="showPhraseDialog = false" round>取 消</el-button>
				<el-button size="medium" type="primary" :loading="phraseSubmitting" @click="submitPhrase" class="gradient-btn" round>保 存</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="editingQuickReplyId ? '编辑快捷词' : '新建快捷词'" :visible.sync="showQuickDialog" width="520px" append-to-body class="custom-dialog">
			<el-form ref="quickForm" :model="quickForm" :rules="quickRules" label-width="100px" size="medium">
				<el-form-item label="快捷词" prop="keyword">
					<el-input v-model="quickForm.keyword" maxlength="32" placeholder="例如：帮助、充值时间" class="custom-input"></el-input>
				</el-form-item>
				<el-form-item label="快捷语" prop="content">
					<el-input v-model="quickForm.content" type="textarea" :rows="4" maxlength="500" placeholder="例如：请联系客服获取帮助" class="custom-input"></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input-number v-model="quickForm.sortOrder" :min="0" :max="9999"></el-input-number>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="showQuickDialog = false" round>取 消</el-button>
				<el-button size="medium" type="primary" :loading="quickSubmitting" @click="submitQuickReply" class="gradient-btn" round>保 存</el-button>
			</span>
		</el-dialog>
	</el-container>
</template>

<script>
import FileUpload from "../components/common/FileUpload.vue";

export default {
	name: "setting",
	components: {
		FileUpload
	},
	data() {
		return {
			activeTab: "info",
			userInfo: {},
			agentSetting: {
				offlineReplyEnabled: false,
				offlineReply: ""
			},
			passwordSubmitting: false,
			passwordForm: {
				oldPassword: "",
				newPassword: "",
				confirmPassword: ""
			},
			maxSize: 5 * 1024 * 1024,
			rules: {
				nickName: [{
					required: true,
					message: '请输入昵称',
					trigger: 'blur'
				}]
			},
			passwordRules: {
				oldPassword: [{
					required: true,
					message: '请输入旧密码',
					trigger: 'blur'
				}],
				newPassword: [{
					required: true,
					message: '请输入新密码',
					trigger: 'blur'
				}, {
					min: 6,
					message: '新密码至少6位',
					trigger: 'blur'
				}],
				confirmPassword: [{
					required: true,
					message: '请再次输入新密码',
					trigger: 'blur'
				}, {
					validator: (rule, value, callback) => {
						if (value !== this.passwordForm.newPassword) {
							callback(new Error('两次输入的新密码不一致'));
						} else {
							callback();
						}
					},
					trigger: 'blur'
				}]
			},
			channels: [],
			channelDomains: [],
			channelLoading: false,
			quickReplyLoading: false,
			phraseLoading: false,
			showChannelDialog: false,
			channelSubmitting: false,
			editingChannelId: null,
			showQuickDialog: false,
			showPhraseDialog: false,
			showPhraseCategoryDialog: false,
			phraseCategorySubmitting: false,
			editingPhraseCategoryId: null,
			phraseSubmitting: false,
			editingPhraseId: null,
			quickSubmitting: false,
			editingQuickReplyId: null,
			phraseCategories: [],
			selectedPhraseCategoryId: null,
			quickReplies: [],
			channelForm: {
				domainId: null,
				channelName: "",
				landingTitle: "",
				landingAvatar: "",
				welcomeMessage: ""
			},
			quickForm: {
				keyword: "",
				content: "",
				sortOrder: 0
			},
			phraseForm: {
				categoryId: null,
				content: "",
				sortOrder: 0
			},
			phraseCategoryForm: {
				name: "",
				sortOrder: 0
			},
			channelRules: {
				domainId: [{
					required: true,
					message: "请选择前端域名",
					trigger: "change"
				}],
				channelName: [{
					required: true,
					message: "请输入渠道名称",
					trigger: "blur"
				}]
			},
			quickRules: {
				keyword: [{
					required: true,
					message: "请输入快捷词",
					trigger: "blur"
				}],
				content: [{
					required: true,
					message: "请输入快捷语",
					trigger: "blur"
				}]
			},
			phraseRules: {
				categoryId: [{
					required: true,
					message: "请选择分类",
					trigger: "change"
				}],
				content: [{
					required: true,
					message: "请输入常用词内容",
					trigger: "blur"
				}]
			},
			phraseCategoryRules: {
				name: [{
					required: true,
					message: "请输入分类名称",
					trigger: "blur"
				}]
			}
		}
	},
	methods: {
		init() {
			let mine = this.userStore.userInfo;
			this.userInfo = JSON.parse(JSON.stringify(mine));
			this.loadAgentSetting();
			this.loadChannelDomains();
			this.loadChannels();
			this.loadQuickReplies();
			this.loadPhraseCategories();
		},
		loadAgentSetting() {
			return this.$http({
				url: "/agent/setting",
				method: "get"
			}).then((setting) => {
				this.agentSetting = {
					offlineReplyEnabled: !!(setting && setting.offlineReplyEnabled),
					offlineReply: setting && setting.offlineReply ? setting.offlineReply : ""
				};
			});
		},
		onSubmit() {
			this.$refs['settingForm'].validate((valid) => {
				if (!valid) {
					return false;
				}
				Promise.all([
					this.$http({
						url: "/user/update",
						method: "put",
						data: this.userInfo
					}),
					this.$http({
						url: "/agent/setting/offline-reply",
						method: "put",
						data: {
							offlineReplyEnabled: !!this.agentSetting.offlineReplyEnabled,
							offlineReply: this.agentSetting.offlineReply || ""
						}
					})
				]).then(() => {
					this.userStore.setUserInfo(this.userInfo);
					this.$message.success("修改成功");
				})
			});
		},
		onUploadSuccess(data, file) {
			this.userInfo.headImage = data.originUrl;
			this.userInfo.headImageThumb = data.thumbUrl;
		},
		submitPassword() {
			this.$refs.passwordForm.validate((valid) => {
				if (!valid) {
					return;
				}
				if (this.passwordForm.oldPassword === this.passwordForm.newPassword) {
					this.$message.warning('新密码不能与旧密码相同');
					return;
				}
				this.passwordSubmitting = true;
				this.$http({
					url: '/modifyPwd',
					method: 'put',
					data: {
						oldPassword: this.passwordForm.oldPassword,
						newPassword: this.passwordForm.newPassword
					}
				}).then(() => {
					this.$message.success('密码修改成功，请使用新密码重新登录');
					this.passwordForm = {
						oldPassword: '',
						newPassword: '',
						confirmPassword: ''
					};
					this.$nextTick(() => {
						if (this.$refs.passwordForm) {
							this.$refs.passwordForm.clearValidate();
						}
					});
					setTimeout(() => {
						if (this.$wsApi) {
							this.$wsApi.close(3000);
						}
						sessionStorage.removeItem('accessToken');
						sessionStorage.removeItem('refreshToken');
						localStorage.setItem('isAutoLogin', false);
						location.href = '/';
					}, 800);
				}).finally(() => {
					this.passwordSubmitting = false;
				});
			});
		},
		loadChannels() {
			this.channelLoading = true;
			return this.$http({
				url: '/agent/channel/list',
				method: 'get'
			}).then((channels) => {
				this.channels = channels || [];
			}).finally(() => {
				this.channelLoading = false;
			});
		},
		loadChannelDomains() {
			return this.$http({
				url: '/agent/channel/domain/list',
				method: 'get'
			}).then((domains) => {
				this.channelDomains = domains || [];
			});
		},
		getPreferredDomainId() {
			const enabledDomains = this.channelDomains.filter(item => item.status === 1);
			const preferred = enabledDomains.find(item => item.isDefault === 1) || enabledDomains[0];
			return preferred ? preferred.id : null;
		},
		formatDomainLabel(domain) {
			const suffix = domain.status === 1 ? '' : '（已停用，仅保留历史链接）';
			return `${domain.domainName} (${domain.entryUrl})${suffix}`;
		},
		isDomainOptionDisabled(domain) {
			return domain.status !== 1 && domain.id !== this.channelForm.domainId;
		},
		openChannelDialog(channel) {
			if (!channel && !this.channelDomains.length) {
				this.$message.warning('请先在总后台配置前端域名');
				return;
			}
			this.editingChannelId = channel ? channel.id : null;
			this.channelForm = {
				domainId: channel ? channel.domainId : this.getPreferredDomainId(),
				channelName: channel ? channel.channelName : "",
				landingTitle: channel ? channel.landingTitle : "",
				landingAvatar: channel ? channel.landingAvatar : "",
				welcomeMessage: channel ? channel.welcomeMessage : ""
			};
			this.showChannelDialog = true;
			this.$nextTick(() => {
				if (this.$refs.channelForm) {
					this.$refs.channelForm.clearValidate();
				}
			});
		},
		submitChannel() {
			this.$refs.channelForm.validate((valid) => {
				if (!valid) {
					return;
				}
				this.channelSubmitting = true;
				const request = this.editingChannelId ? {
					url: '/agent/channel/update',
					method: 'put',
					data: {
						channelId: this.editingChannelId,
						...this.channelForm
					}
				} : {
					url: '/agent/channel/create',
					method: 'post',
					data: {
						agentUserId: this.userStore.userInfo.id,
						...this.channelForm
					}
				};
				this.$http(request).then(() => {
					this.$message.success(this.editingChannelId ? '更新成功' : '创建成功');
					this.showChannelDialog = false;
					this.loadChannels();
				}).finally(() => {
					this.channelSubmitting = false;
				});
			});
		},
		toggleChannelStatus(channel) {
			const nextStatus = channel.status === 1 ? 0 : 1;
			this.$http({
				url: '/agent/channel/status',
				method: 'put',
				data: {
					channelId: channel.id,
					status: nextStatus
				}
			}).then(() => {
				this.$message.success(nextStatus === 1 ? '已启用' : '已停用');
				this.loadChannels();
			});
		},
		loadQuickReplies() {
			this.quickReplyLoading = true;
			return this.$http({
				url: '/agent/quick-reply/list',
				method: 'get'
			}).then((list) => {
				this.quickReplies = list || [];
			}).finally(() => {
				this.quickReplyLoading = false;
			});
		},
		loadPhraseCategories() {
			this.phraseLoading = true;
			return this.$http({
				url: '/agent/common-phrase/tree',
				method: 'get'
			}).then((list) => {
				this.phraseCategories = list || [];
				if (!this.selectedPhraseCategoryId && this.phraseCategories.length) {
					this.selectedPhraseCategoryId = this.phraseCategories[0].id;
				} else if (this.selectedPhraseCategoryId
					&& !this.phraseCategories.some(item => item.id === this.selectedPhraseCategoryId)) {
					this.selectedPhraseCategoryId = this.phraseCategories.length ? this.phraseCategories[0].id : null;
				}
			}).finally(() => {
				this.phraseLoading = false;
			});
		},
		selectPhraseCategory(category) {
			this.selectedPhraseCategoryId = category.id;
		},
		openPhraseCategoryDialog(category) {
			this.editingPhraseCategoryId = category ? category.id : null;
			this.phraseCategoryForm = {
				name: category ? category.name : "",
				sortOrder: category ? (category.sortOrder || 0) : this.phraseCategories.length
			};
			this.showPhraseCategoryDialog = true;
			this.$nextTick(() => {
				if (this.$refs.phraseCategoryFormRef) {
					this.$refs.phraseCategoryFormRef.clearValidate();
				}
			});
		},
		submitPhraseCategory() {
			this.$refs.phraseCategoryFormRef.validate((valid) => {
				if (!valid) {
					return;
				}
				this.phraseCategorySubmitting = true;
				this.$http({
					url: '/agent/common-phrase/category/save',
					method: 'post',
					data: {
						id: this.editingPhraseCategoryId,
						name: this.phraseCategoryForm.name,
						sortOrder: this.phraseCategoryForm.sortOrder,
						status: 1
					}
				}).then((category) => {
					this.$message.success(this.editingPhraseCategoryId ? '更新成功' : '创建成功');
					this.showPhraseCategoryDialog = false;
					if (!this.editingPhraseCategoryId && category && category.id) {
						this.selectedPhraseCategoryId = category.id;
					}
					this.loadPhraseCategories();
				}).finally(() => {
					this.phraseCategorySubmitting = false;
				});
			});
		},
		deletePhraseCategory(category) {
			this.$confirm(`确认删除分类“${category.name}”吗？分类下的常用词也会一起删除。`, '提示', { type: 'warning' }).then(() => {
				this.$http({
					url: `/agent/common-phrase/category/delete/${category.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success('删除成功');
					if (this.selectedPhraseCategoryId === category.id) {
						this.selectedPhraseCategoryId = null;
					}
					this.loadPhraseCategories();
				});
			}).catch(() => {});
		},
		openPhraseDialog(row) {
			if (!row && !this.phraseCategories.length) {
				this.$message.warning('请先创建分类');
				return;
			}
			this.editingPhraseId = row ? row.id : null;
			this.phraseForm = {
				categoryId: row ? row.categoryId : this.selectedPhraseCategoryId,
				content: row ? row.content : "",
				sortOrder: row ? (row.sortOrder || 0) : this.currentPhrases.length
			};
			this.showPhraseDialog = true;
			this.$nextTick(() => {
				if (this.$refs.phraseFormRef) {
					this.$refs.phraseFormRef.clearValidate();
				}
			});
		},
		submitPhrase() {
			this.$refs.phraseFormRef.validate((valid) => {
				if (!valid) {
					return;
				}
				this.phraseSubmitting = true;
				this.$http({
					url: '/agent/common-phrase/save',
					method: 'post',
					data: {
						id: this.editingPhraseId,
						categoryId: this.phraseForm.categoryId,
						content: this.phraseForm.content,
						sortOrder: this.phraseForm.sortOrder,
						status: 1
					}
				}).then(() => {
					this.$message.success(this.editingPhraseId ? '更新成功' : '创建成功');
					this.showPhraseDialog = false;
					this.loadPhraseCategories();
				}).finally(() => {
					this.phraseSubmitting = false;
				});
			});
		},
		togglePhraseStatus(row) {
			const nextStatus = row.status === 1 ? 0 : 1;
			this.$http({
				url: '/agent/common-phrase/save',
				method: 'post',
				data: {
					id: row.id,
					categoryId: row.categoryId,
					content: row.content,
					sortOrder: row.sortOrder || 0,
					status: nextStatus
				}
			}).then(() => {
				this.$message.success(nextStatus === 1 ? '已启用' : '已停用');
				this.loadPhraseCategories();
			});
		},
		deletePhrase(row) {
			this.$confirm('确认删除该常用词吗？', '提示', { type: 'warning' }).then(() => {
				this.$http({
					url: `/agent/common-phrase/delete/${row.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success('删除成功');
					this.loadPhraseCategories();
				});
			}).catch(() => {});
		},
		openQuickDialog(row) {
			this.editingQuickReplyId = row ? row.id : null;
			this.quickForm = {
				keyword: row ? row.keyword : "",
				content: row ? row.content : "",
				sortOrder: row ? (row.sortOrder || 0) : this.quickReplies.length
			};
			this.showQuickDialog = true;
			this.$nextTick(() => {
				if (this.$refs.quickForm) {
					this.$refs.quickForm.clearValidate();
				}
			});
		},
		submitQuickReply() {
			this.$refs.quickForm.validate((valid) => {
				if (!valid) {
					return;
				}
				this.quickSubmitting = true;
				this.$http({
					url: '/agent/quick-reply/save',
					method: 'post',
					data: {
						id: this.editingQuickReplyId,
						keyword: this.quickForm.keyword,
						content: this.quickForm.content,
						sortOrder: this.quickForm.sortOrder,
						status: 1
					}
				}).then(() => {
					this.$message.success(this.editingQuickReplyId ? '更新成功' : '创建成功');
					this.showQuickDialog = false;
					this.loadQuickReplies();
				}).finally(() => {
					this.quickSubmitting = false;
				});
			});
		},
		toggleQuickReplyStatus(row) {
			const nextStatus = row.status === 1 ? 0 : 1;
			this.$http({
				url: '/agent/quick-reply/save',
				method: 'post',
				data: {
					id: row.id,
					keyword: row.keyword,
					content: row.content,
					sortOrder: row.sortOrder || 0,
					status: nextStatus
				}
			}).then(() => {
				this.$message.success(nextStatus === 1 ? '已启用' : '已停用');
				this.loadQuickReplies();
			});
		},
		deleteQuickReply(row) {
			this.$confirm('确认删除该快捷词吗？', '提示', { type: 'warning' }).then(() => {
				this.$http({
					url: `/agent/quick-reply/delete/${row.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success('删除成功');
					this.loadQuickReplies();
				});
			}).catch(() => {});
		},
		copyLink(link) {
			const input = document.createElement('textarea');
			input.value = link;
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
			this.$message.success('链接已复制');
		}
	},
	computed: {
		imageAction() {
			return `/image/upload?thumbSize=20`;
		},
		selectedPhraseCategory() {
			return this.phraseCategories.find(item => item.id === this.selectedPhraseCategoryId) || null;
		},
		selectedPhraseCategoryName() {
			return this.selectedPhraseCategory ? this.selectedPhraseCategory.name : '请选择分类';
		},
		currentPhrases() {
			if (!this.selectedPhraseCategory) {
				return [];
			}
			return this.selectedPhraseCategory.phrases || [];
		}
	},
	mounted() {
		if (this.$route.query.tab === 'phrase') {
			this.activeTab = 'phrase';
		}
		this.init();
	}
}
</script>

<style lang="scss" scoped>
.setting-page {
	height: 100%;
	background: linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%);
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
	position: relative;
	box-sizing: border-box;
	padding: 16px 20px 0;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 70%);
		pointer-events: none;
	}

	:deep(.el-main) {
		padding: 0 !important;
		width: 100%;
		height: 100%;
	}

	.setting-container {
		width: 62vw;
		height: 80vh;
		max-width: 1100px;
		min-height: 600px;
		min-width: 970px;
		background: #fff;
		border-radius: 16px;
		display: flex;
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
		overflow: hidden;
		border: 1px solid rgba(255, 255, 255, 0.3);
		backdrop-filter: blur(10px);
		margin: 0 auto;
	}

	.setting-aside {
		width: 240px;
		background-color: #fcfcfd;
		border-right: 1px solid #f0f3f5;
		padding: 30px 0;

		.setting-title {
			padding: 0 25px 20px;
			font-size: 18px;
			font-weight: 600;
			color: #1f1f1f;
			letter-spacing: 0.5px;
		}

		.setting-menu {
			.menu-item {
				padding: 14px 25px;
				cursor: pointer;
				display: flex;
				align-items: center;
				gap: 12px;
				color: #595959;
				font-size: 14px;
				transition: all 0.3s;
				position: relative;

				i {
					font-size: 18px;
				}

				&:hover {
					color: var(--im-color-primary);
					background-color: #f0f7ff;
				}

				&.active {
					color: var(--im-color-primary);
					background-color: #e6f0ff;
					font-weight: 600;

					&::after {
						content: '';
						position: absolute;
						right: 0;
						top: 0;
						bottom: 0;
						width: 3px;
						background: var(--im-color-primary);
					}
				}
			}
		}
	}

	.setting-content {
		flex: 1;
		padding: 40px 50px;
		overflow-y: auto;

		.content-pane {
			.pane-header {
				font-size: 22px;
				font-weight: 600;
				color: #262626;
				margin-bottom: 35px;
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
		}
	}

	// 个人信息样式
	.info-form-wrap {
		max-width: 600px;

		.avatar-uploader {
			.avatar-wrap {
				position: relative;
				width: 100px;
				height: 100px;
				border-radius: 50%;
				overflow: hidden;
				cursor: pointer;
				border: 2px solid #fff;
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

				.avatar {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}

				.avatar-placeholder {
					width: 100%;
					height: 100%;
					background-color: #fafafa;
					display: flex;
					align-items: center;
					justify-content: center;
					color: #bfbfbf;
					font-size: 24px;
				}

				.avatar-mask {
					position: absolute;
					inset: 0;
					background: rgba(0, 0, 0, 0.45);
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					color: #fff;
					opacity: 0;
					transition: opacity 0.3s;
					font-size: 12px;
					gap: 4px;

					i {
						font-size: 20px;
					}
				}

				&:hover .avatar-mask {
					opacity: 1;
				}
			}
		}

		.custom-input {
			:deep(.el-input__inner), :deep(.el-textarea__inner) {
				border-radius: 8px;
				background-color: #f9f9f9;
				border-color: #eee;
				transition: all 0.3s;

				&:focus {
					background-color: #fff;
					border-color: var(--im-color-primary);
					box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
				}
			}
		}

		.form-actions {
			margin-top: 40px;
		}

		.offline-reply-card {
			padding: 18px 20px;
			border-radius: 14px;
			background: linear-gradient(180deg, #f8fbff 0%, #f3f7fc 100%);
			border: 1px solid #e8eef5;
		}

		.offline-reply-input {
			margin-top: 14px;
		}

		.offline-reply-tip {
			margin-top: 10px;
			font-size: 12px;
			line-height: 18px;
			color: #7b8794;
		}
	}

	.quick-setting-tip {
		margin: -20px 0 20px;
		padding: 12px 14px;
		border-radius: 10px;
		background: #f8fbff;
		border: 1px solid #e8eef5;
		font-size: 13px;
		line-height: 20px;
		color: #7b8794;
	}

	.quick-form-tip {
		margin-top: 6px;
		font-size: 12px;
		line-height: 18px;
		color: #909399;
	}

	.quick-manage-wrap {
		display: flex;
		gap: 16px;
		min-height: 420px;
	}

	.quick-category-panel,
	.quick-reply-panel {
		flex: 1;
		min-width: 0;
		border: 1px solid #eef2f6;
		border-radius: 12px;
		background: #fcfcfd;
		padding: 16px;
	}

	.quick-category-panel {
		flex: 0 0 260px;
	}

	.panel-title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 14px;
		font-size: 15px;
		font-weight: 600;
		color: #303133;
	}

	.panel-sub {
		font-size: 12px;
		font-weight: 400;
		color: #909399;
	}

	.category-item {
		padding: 12px;
		border-radius: 10px;
		border: 1px solid transparent;
		cursor: pointer;
		transition: all 0.2s;
		margin-bottom: 8px;
		background: #fff;

		&:hover,
		&.active {
			border-color: #d9ecff;
			background: #f0f7ff;
		}
	}

	.category-item-main {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
	}

	.category-item-name {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 14px;
		color: #303133;
	}

	.category-item-count {
		font-size: 12px;
		color: #909399;
	}

	.category-item-actions {
		margin-top: 8px;
		display: flex;
		justify-content: flex-end;
		gap: 4px;
	}

	.danger-text {
		color: #ff4d4f !important;
	}

	.pane-header-actions {
		display: flex;
		gap: 8px;
	}

	.empty-holder.small {
		padding: 24px 0;
	}

	// 接入链接样式
	.channel-list-wrap {
		.custom-table {
			border-radius: 8px;
			overflow: hidden;
			
			:deep(th) {
				background-color: #fafafa !important;
				color: #595959;
				font-weight: 600;
			}
		}

		.status-dot {
			display: inline-flex;
			align-items: center;
			gap: 6px;
			font-size: 13px;

			&::before {
				content: '';
				width: 8px;
				height: 8px;
				border-radius: 50%;
			}

			&.online {
				color: #52c41a;
				&::before { background-color: #52c41a; box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.2); }
			}

			&.offline {
				color: #bfbfbf;
				&::before { background-color: #bfbfbf; }
			}
		}

		.link-box {
			display: flex;
			align-items: center;
			background: #f5f5f5;
			padding: 4px 10px;
			border-radius: 4px;
			gap: 8px;

			.link-url {
				flex: 1;
				font-size: 12px;
				color: #8c8c8c;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}

		.action-btn {
			font-weight: 500;
			&.edit { color: var(--im-color-primary); }
			&.disable { color: #ff4d4f; }
			&.enable { color: #52c41a; }
		}

		.empty-holder {
			padding: 60px 0;
			text-align: center;
			color: #bfbfbf;

			i {
				font-size: 48px;
				margin-bottom: 15px;
			}
			p { font-size: 14px; }
		}
	}

	.channel-domain-tip {
		margin-top: 6px;
		font-size: 12px;
		line-height: 18px;
		color: #8c8c8c;
	}

	// 通用组件样式
	.gradient-btn {
		background: linear-gradient(135deg, var(--im-color-primary-light-2) 0%, var(--im-color-primary) 100%);
		border: none;
		padding: 12px 30px;
		font-weight: 600;
		box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
		transition: all 0.3s;

		&:hover {
			transform: translateY(-1px);
			box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
			opacity: 0.9;
		}

		&:active {
			transform: translateY(0);
		}
	}

	.gradient-btn-small {
		@extend .gradient-btn;
		padding: 8px 16px;
		font-size: 13px;
	}

	.fade-in {
		animation: fadeIn 0.4s ease-out;
	}

	@keyframes fadeIn {
		from { opacity: 0; transform: translateY(10px); }
		to { opacity: 1; transform: translateY(0); }
	}
}

// 弹窗样式定制
.custom-dialog {
	:deep(.el-dialog) {
		border-radius: 12px;
		overflow: hidden;
	}
	:deep(.el-dialog__header) {
		padding: 20px 25px;
		border-bottom: 1px solid #f0f0f0;
		.el-dialog__title { font-weight: 600; }
	}
	:deep(.el-dialog__body) {
		padding: 30px 25px;
	}
}

@media (max-width: 900px) {
	.custom-dialog {
		:deep(.el-dialog) {
			width: 94% !important;
			margin-top: 4vh !important;
		}

		:deep(.el-dialog__header) {
			padding: 14px 14px 12px;
		}

		:deep(.el-dialog__body) {
			padding: 14px 12px 10px;
			max-height: 72vh;
			overflow-y: auto;
		}

		:deep(.el-dialog__footer) {
			padding: 10px 12px calc(env(safe-area-inset-bottom) + 10px);
			border-top: 1px solid #eef2f6;
		}

		:deep(.el-form-item) {
			margin-bottom: 14px;
		}

		:deep(.el-form-item__label) {
			float: none;
			display: block;
			text-align: left;
			width: auto !important;
			padding: 0 0 6px;
			line-height: 20px;
		}

		:deep(.el-form-item__content) {
			margin-left: 0 !important;
		}

		:deep(.dialog-footer) {
			display: flex;
			gap: 8px;
			justify-content: flex-end;

			.el-button {
				min-width: 92px;
			}
		}
	}

	.setting-page {
		padding: 8px;

		.setting-container {
			width: 100%;
			height: calc(100vh - 16px);
			min-width: 0;
			min-height: 0;
			max-width: none;
			border-radius: 12px;
			flex-direction: column;
		}

		.setting-aside {
			width: 100%;
			padding: 10px 0;
			border-right: none;
			border-bottom: 1px solid #eef2f6;

			.setting-title {
				padding: 0 14px 8px;
				font-size: 16px;
			}

			.setting-menu {
				display: flex;
				padding: 0 8px;
				gap: 8px;

				.menu-item {
					flex: 1;
					justify-content: center;
					padding: 10px 8px;
					border-radius: 8px;

					&.active::after {
						display: none;
					}
				}
			}
		}

		.setting-content {
			padding: 14px 12px;
			padding-bottom: 80px;

			.content-pane .pane-header {
				font-size: 18px;
				margin-bottom: 14px;
			}
		}

		.info-form-wrap {
			max-width: none;

			.form-actions {
				position: sticky;
				bottom: -14px;
				margin: 10px 0 0;
				padding: 10px 0 calc(env(safe-area-inset-bottom) + 8px);
				background: linear-gradient(180deg, rgba(255, 255, 255, 0.75) 0%, #fff 45%);
				backdrop-filter: blur(3px);
				z-index: 3;

				.gradient-btn {
					width: 100%;
					padding: 11px 12px;
				}
			}
		}
	}
}
</style>